import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Admission from './pages/Admission';
import Academics from './pages/Academics';
import Contact from './pages/Contact';
import EventDetails from './pages/EventDetails';
import Orientations from './pages/Orientations';
import Results from './pages/Results';
import Syllabus from './pages/Syllabus';
import Booklist from './pages/Booklist';
import Curriculum from './pages/Curriculum';
import Sports from './pages/Sports';
import DailyMedia from './pages/DailyMedia';
import DailyMediaDetails from './pages/DailyMediaDetails';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/admission" element={<Admission />} />
            <Route path="/academics" element={<Academics />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/event-details/:id" element={<EventDetails />} />
            <Route path="/orientations" element={<Orientations />} />
            <Route path="/results" element={<Results />} />
            <Route path="/syllabus" element={<Syllabus />} />
            <Route path="/booklist" element={<Booklist />} />
            <Route path="/curriculum" element={<Curriculum />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/daily-media" element={<DailyMedia />} />
            <Route path="/daily-media/:id" element={<DailyMediaDetails />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
